const state = {
  spinnerStatus: 0,
  spinnerVisible: false,
};

const mutations = {
  CHANGE_SPINER_VISIBLE(state, spinnerVisible) {
    state.spinnerVisible = spinnerVisible;
  },
  CHANGE_SPINER_STATUS(state, spinnerStatus) {
    state.spinnerStatus = spinnerStatus;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  spinnerStatus: (state) => {
    return state.spinnerStatus;
  },
  spinnerVisible: (state) => {
    return state.spinnerVisible;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
